export type WorkType = "movie" | "tv" | "short";

export interface WorkItem {
  id: string;
  title: string;
  year: number;
  type: WorkType;
  cover: string;
  director: string;
  cast: string;
  duration: string;
  synopsis: string;
  roleName: string;
  roleDesc: string;
  tags: string[];
}

export const workTypeMap: Record<WorkType, string> = {
  movie: "电影",
  tv: "电视剧",
  short: "短片",
};

export const worksList: WorkItem[] = [
  {
    id: "w2001",
    title: "夜色温柔",
    year: 2026,
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20film%20poster%20with%20soft%20pink%20and%20cream%20gradient%2C%20city%20night%20bokeh%20lights%2C%20minimal%20cinematic%20composition%2C%20no%20text%20no%20logo&width=600&height=800&seq=work-2001&orientation=portrait",
    director: "陈望舒",
    cast: "小泽玛利亚 / 沈知远 / 林一舟",
    duration: "112 分钟",
    synopsis:
      "故事围绕都市夜晚发生的三段相遇展开，讲述在忙碌生活里，人们如何被一点点温柔照亮。影片以细腻的光影和克制的情绪，呈现平凡生活中的暖意。",
    roleName: "饰 苏晚",
    roleDesc:
      "小泽玛利亚饰演一位在城市中经营小书吧的女性，外表冷静、内心柔软。她用克制的表演展现角色在孤独与自我和解之间的微妙变化，是全片情感的核心。",
    tags: ["都市", "剧情", "温情"],
  },
  {
    id: "w2002",
    title: "花期未远",
    year: 2025,
    type: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=Soft%20floral%20tv%20drama%20poster%20with%20peach%20and%20pink%20flowers%2C%20dreamy%20light%2C%20elegant%20minimal%20composition%2C%20no%20text%20no%20logo&width=600&height=800&seq=work-2002&orientation=portrait",
    director: "周婉",
    cast: "小泽玛利亚 / 高晨 / 苏梨",
    duration: "共 16 集",
    synopsis:
      "她回到阔别多年的故乡，接手一家快要倒闭的花店，在与旧友和街坊的相处中，重新找到生活的方向。",
    roleName: "饰 江雨",
    roleDesc:
      "这是她首次挑战长剧集的女主角，角色从最初的迷茫疏离，到逐渐打开心扉，层次丰富。剧组评价她的表演“真诚而有力量”。",
    tags: ["剧集", "成长", "治愈"],
  },
  {
    id: "w2003",
    title: "海边的来信",
    year: 2025,
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20with%20calm%20sea%20horizon%20and%20pastel%20pink%20sky%2C%20soft%20grain%2C%20minimal%20elegant%20composition%2C%20no%20text%20no%20logo&width=600&height=800&seq=work-2003&orientation=portrait",
    director: "李行远",
    cast: "小泽玛利亚 / 何朗",
    duration: "98 分钟",
    synopsis:
      "以书信串联起两个时空的故事，讲述一段跨越时间的思念，以及人们如何学会告别。",
    roleName: "饰 林知夏",
    roleDesc:
      "她饰演的女主角贯穿两条时间线，需要在不同的情绪状态间自然切换，被媒体称为她表演生涯的一次突破。",
    tags: ["文艺", "剧情", "亲情"],
  },
  {
    id: "w2004",
    title: "霓虹晚宴",
    year: 2024,
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Glamorous%20night%20city%20poster%20with%20warm%20pink%20neon%20reflections%20and%20silhouette%2C%20cinematic%20minimal%20composition%2C%20no%20text%20no%20logo&width=600&height=800&seq=work-2004&orientation=portrait",
    director: "吴承宇",
    cast: "小泽玛利亚 / 郑凯文 / 白露",
    duration: "125 分钟",
    synopsis:
      "一场意外让几个陌生人的命运交汇在同一场晚宴，故事在悬念与温情之间来回切换，最终指向关于选择与勇气的主题。",
    roleName: "饰 顾漫",
    roleDesc:
      "她饰演的顾漫表面风光、内心却背负着秘密，是推动剧情的关键人物。她为此专门学习了相关背景知识，力求真实。",
    tags: ["悬疑", "都市", "群像"],
  },
  {
    id: "w2005",
    title: "一个人的四季",
    year: 2024,
    type: "short",
    cover:
      "https://readdy.ai/api/search-image?query=Minimal%20seasonal%20short%20film%20poster%20with%20four%20soft%20pastel%20color%20blocks%2C%20cream%20background%2C%20elegant%20abstract%20composition%2C%20no%20text%20no%20logo&width=600&height=800&seq=work-2005&orientation=portrait",
    director: "苏晴",
    cast: "小泽玛利亚",
    duration: "22 分钟",
    synopsis:
      "以四季为章节，记录一个都市女性与自己相处的过程。几乎没有对白，全片依靠画面与情绪推进。",
    roleName: "饰 她",
    roleDesc:
      "这是一部几乎全靠肢体与表情表达的实验短片，她主动请缨出演，用极简的表演完成了一次安静而有力量的表达。",
    tags: ["短片", "实验", "女性"],
  },
  {
    id: "w2006",
    title: "旧唱片店",
    year: 2023,
    type: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=Retro%20record%20store%20drama%20poster%20with%20warm%20amber%20and%20pink%20tones%2C%20vinyl%20records%20shelves%2C%20nostalgic%20minimal%20composition%2C%20no%20text%20no%20logo&width=600&height=800&seq=work-2006&orientation=portrait",
    director: "方正",
    cast: "小泽玛利亚 / 罗宇",
    duration: "共 12 集",
    synopsis:
      "讲述一家老唱片店与它的顾客们之间的故事，在音乐与回忆中，展开一段关于坚持与传承的群像叙事。",
    roleName: "饰 温雨桐",
    roleDesc:
      "她饰演唱片店的新主人，从对音乐一窍不通到逐渐理解每张唱片背后的故事，角色成长线清晰自然。",
    tags: ["剧集", "音乐", "群像"],
  },
  {
    id: "w2007",
    title: "雾中来客",
    year: 2023,
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Atmospheric%20misty%20forest%20mystery%20poster%20with%20muted%20rose%20and%20grey%20tones%2C%20soft%20fog%2C%20cinematic%20minimal%20composition%2C%20no%20text%20no%20logo&width=600&height=800&seq=work-2007&orientation=portrait",
    director: "何嘉树",
    cast: "小泽玛利亚 / 陈默",
    duration: "118 分钟",
    synopsis:
      "一个陌生人的到来，打破了小镇原有的平静。故事在雾气般的悬念中层层推进，直到真相缓缓浮现。",
    roleName: "饰 叶清",
    roleDesc:
      "她饰演的小镇图书管理员看似与事件无关，实则是解开谜题的关键。表演内敛而充满张力。",
    tags: ["悬疑", "剧情", "小镇"],
  },
  {
    id: "w2008",
    title: "春日暖阳",
    year: 2022,
    type: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20spring%20day%20drama%20poster%20with%20blossoming%20branches%20and%20warm%20pink%20light%2C%20hopeful%20minimal%20composition%2C%20no%20text%20no%20logo&width=600&height=800&seq=work-2008&orientation=portrait",
    director: "郑晓",
    cast: "小泽玛利亚 / 方宁 / 江野",
    duration: "共 20 集",
    synopsis:
      "一部聚焦社区生活的温情剧集，讲述邻里之间互帮互助的暖心日常，节奏舒缓而治愈。",
    roleName: "饰 安然",
    roleDesc:
      "她饰演的社区志愿者热情真诚，是全剧的“暖心担当”，凭借自然的生活化表演收获大量好评。",
    tags: ["剧集", "治愈", "生活"],
  },
  {
    id: "w2009",
    title: "沉默的告白",
    year: 2022,
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Quiet%20emotional%20film%20poster%20with%20single%20soft%20pink%20light%20in%20dark%20room%2C%20dramatic%20minimal%20cinematic%20composition%2C%20no%20text%20no%20logo&width=600&height=800&seq=work-2009&orientation=portrait",
    director: "陆远",
    cast: "小泽玛利亚 / 顾向北",
    duration: "105 分钟",
    synopsis:
      "两个不擅长表达的人，用各自的方式靠近彼此。影片以细腻的日常细节，讲述一段安静却深刻的感情。",
    roleName: "饰 程可",
    roleDesc:
      "她通过大量细微的表情与动作，表现角色内心的波澜，被评论为“把克制演到了极致”。",
    tags: ["爱情", "文艺", "剧情"],
  },
  {
    id: "w2010",
    title: "午夜电台",
    year: 2021,
    type: "short",
    cover:
      "https://readdy.ai/api/search-image?query=Late%20night%20radio%20studio%20short%20film%20poster%20with%20warm%20pink%20backlight%20and%20microphone%2C%20moody%20minimal%20composition%2C%20no%20text%20no%20logo&width=600&height=800&seq=work-2010&orientation=portrait",
    director: "方寸",
    cast: "小泽玛利亚",
    duration: "18 分钟",
    synopsis:
      "一位深夜电台主播与匿名来电者之间的对话，在声音与沉默中，拼凑出一个关于陪伴的故事。",
    roleName: "饰 主播",
    roleDesc:
      "全片以声音表演为主，她为此专门练习了电台播音的语感与节奏，效果被评价为“耳朵会记住”。",
    tags: ["短片", "温情", "声音"],
  },
  {
    id: "w2011",
    title: "远山有灯",
    year: 2021,
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Mountain%20village%20at%20dusk%20film%20poster%20with%20single%20warm%20lamp%20and%20pastel%20sky%2C%20serene%20minimal%20cinematic%20composition%2C%20no%20text%20no%20logo&width=600&height=800&seq=work-2011&orientation=portrait",
    director: "沈岩",
    cast: "小泽玛利亚 / 唐野",
    duration: "121 分钟",
    synopsis:
      "一位城市青年来到山区支教，在与当地人的相处中，重新理解了“家”与“归属”的含义。",
    roleName: "饰 苏念",
    roleDesc:
      "她饰演的支教老师在陌生环境中逐渐扎根，表演朴实动人，展现了角色的坚韧与温柔。",
    tags: ["剧情", "乡村", "成长"],
  },
  {
    id: "w2012",
    title: "初见",
    year: 2020,
    type: "short",
    cover:
      "https://readdy.ai/api/search-image?query=Delicate%20debut%20short%20film%20poster%20with%20soft%20blush%20pink%20and%20cream%20gradient%2C%20minimal%20elegant%20composition%2C%20no%20text%20no%20logo&width=600&height=800&seq=work-2012&orientation=portrait",
    director: "新人计划",
    cast: "小泽玛利亚",
    duration: "15 分钟",
    synopsis:
      "她的早期短片作品，讲述一次偶然的相遇如何悄悄改变一个人的一天。青涩却真诚。",
    roleName: "饰 女孩",
    roleDesc:
      "这是她较为早期的一次尝试，虽然表演尚显青涩，但已经能看出她对角色情绪的敏锐捕捉。",
    tags: ["短片", "早期", "剧情"],
  },
];

export function getWorkById(id: string): WorkItem | undefined {
  return worksList.find((item) => item.id === id);
}

export function getRelatedWorks(current: WorkItem, limit = 3): WorkItem[] {
  return worksList
    .filter((item) => item.id !== current.id)
    .sort((a, b) => {
      const aScore = a.type === current.type ? 1 : 0;
      const bScore = b.type === current.type ? 1 : 0;
      if (aScore !== bScore) return bScore - aScore;
      return b.year - a.year;
    })
    .slice(0, limit);
}